<template>
  <div class="position-relative">
    <BaseTopLine> </BaseTopLine>
    <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px] tw-text-white"
      :key="counter"
    >
      <div class="tw-flex tw-justify-between tw-items-end">
        <div class="tw-flex tw-items-end tw-gap-[20px]">
          <div class="tw-app-input-container">
            <label class="tw-app-input-container-label">
              {{ dataLang["reestr_fines_text6"] }}
            </label>
            <BaseInputNew
              @keyupEnter="loadData()"
              class="tw-w-[300px]"
              inputClass="tw-app-input-dark"
              placeholder=""
              @input="
                (data) => {
                  topFillFilter(data);
                }
              "
              :additionalParams="{ type: 'like' }"
              inputName="vehicle_fines__bill_id"
              value=""
              nameSign=""
            />
          </div>

          <div class="tw-app-input-container">
            <label class="tw-app-input-container-label">
              {{ dataLang["reestr_fines_text7"] }}
            </label>
            <BaseInputNew
              @keyupEnter="loadData()"
              class="tw-w-[300px]"
              inputClass="tw-app-input-dark"
              placeholder=""
              @input="
                (data) => {
                  topFillFilter(data);
                }
              "
              :additionalParams="{ type: 'like' }"
              inputName="vehicles__gosnumber"
              inputRef="clients__phoneHGHа"
              value=""
              nameSign=""
            />
          </div>

          <div class="tw-app-input-container">
            <label class="tw-app-input-container-label">
              {{ dataLang["reestr_fines_text8"] }}
            </label>
            <BaseInputNew
              @keyupEnter="loadData()"
              class="tw-w-[300px]"
              inputClass="tw-app-input-dark"
              placeholder=""
              @input="
                (data) => {
                  topFillFilter(data);
                }
              "
              :additionalParams="{ type: 'like' }"
              inputName="clients__name"
              value=""
              nameSign=""
            />
          </div>

          <div class="tw-app-input-container multiselect-type-1">
            <label class="tw-app-input-container-label">
              {{ dataLang["reestr_fines_text31"] }}
            </label>
            <BaseSelect
              class="!tw-w-[300px]"
              v-model="selectsFilter.statuses"
              @input="
                (e, w) => {
                  this.fillFilter({
                    name: 'vehicle_fines_statuses__id',
                    value: e.value,
                    operator: '=',
                  })
                }
              "
              label="label"
              id="ads__id"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              :options="[
                {
                  label: dataLang['fine_status_nopayed'],
                  value: 1,
                },
                {
                  label: dataLang['fine_status_payed'],
                  value: 2,
                },
                {
                  label: 'Любой',
                  value: null,
                },
              ]"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template>
              <template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>

          <div class="tw-flex">
            <button
              type="button"
              class="tw-app-btn-primary"
              @click="loadData()"
            >
              {{ dataLang["reestr_fines_text9"] }}
            </button>
            <button type="button" class="tw-app-btn-light" @click="resetFilter">
              Сбросить
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="tw-flex tw-justify-between tw-my-[10px] tw-mx-[26px]">
      <button
        class="tw-app-btn-primary tw-app-btn-primary-outline"
        @click="attachIntruderOpenModal"
      >
        {{ dataLang["reestr_fines_text10"] }}
      </button>

      <div class="tw-flex tw-gap-[10px]">
        <button
          class="tw-app-btn-primary"
          @click="checkAcceptCheckbox('oneClickModal')"
        >
          {{ dataLang["reestr_fines_text11"] }}
        </button>

        <button
          class="tw-app-btn-muted tw-app-btn-muted"
          @click="checkAcceptCheckbox('cancelFinesModal')"
        >
          {{ dataLang["reestr_fines_text12"] }}
        </button>

        <button
          class="tw-app-btn-primary tw-app-btn-primary-outline tw-app-btn-lock"
          @click="checkAcceptCheckbox('markAsPaidModal')"
        >
          {{ dataLang["reestr_fines_text13"] }}
        </button>

        <button
          class="tw-app-btn-primary tw-app-btn-primary-outline tw-app-btn-lock"
          @click="toExcel"
        >
          в Excel
        </button>
      </div>
    </div>

    <div class="tw-mx-[26px]">
      <div
        v-if="isShowNotification"
        class="tw-inline-block tw-relative tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-bg-[linear-gradient(270.06deg,#fac7c8_1.55%,#fcd4d5_121.66%)]"
      >
        <div class="tw-text-[15px] tw-mb-[10px] tw-font-semibold">
          {{ notificationData.title }}
        </div>
        <div class="tw-text-[12px]" v-html="notificationData.text"></div>
        <button
          class="btn-close tw-absolute tw-top-[10px] tw-right-[10px]"
          @click="isShowNotification = false"
        ></button>
      </div>
    </div>

    <div class="tw-relative tw-mx-[26px]" style="min-height: 250px">
      <BaseLoader v-if="localLoading"></BaseLoader>

      <div class="tw-flex tw-justify-end tw-my-[15px]">
        <TwBasePagination
          :page-count="numPages"
          :pagination-params="{
            ...paginationFinesStateParams,
            limit: limitPaginationValue,
          }"
          :showLimitInput="true"
          @updateLimitValue="updateLimitValue"
          :page-range="10"
          :margin-pages="0"
          :click-handler="loadData"
        >
        </TwBasePagination>
      </div>

      <div style="min-height: 400px">
        <ve-table
          class="fixed-header rest-style-table"
          style="width: 100%"
          :columns="columns"
          :table-data="dataTable"
          :border-x="true"
          :border-y="true"
          row-key-field-name="vehicle_fines__id"
          ref="mainTable"
          :eventCustomOption="eventCustomOption"
          v-if="!localLoading"
          :checkbox-option="{
            selectedRowChange: selectedRowChange,
            selectedAllChange: selectedAllChange,
            hideSelectAll: false,
            selectedRowKeys: activeSelectRowsMultiple,
          }"
          :clickHighlight="false"
          :cell-style-option="cellStyleOption"
          :rowStyleOption="{
            hoverHighlight: true,
          }"
          :cellSelectionOption="{ enable: false }"
        >
        </ve-table>
      </div>
    </div>

    <BaseModal
      name="acceptDelete"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('acceptDelete')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang.confirm_dialog_delete }}
          </div>
        </div>

        <div class="tw-app-modal__footer">
          <button
            @click="$modal.hide('acceptDelete')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            Отмена
          </button>
          <button
            @click="deleteRow"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            {{ dataLang.confirm_btn__btn_yes }}
          </button>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="acceptDeleteWithPin"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      @before-close="pincodeModalHandler"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('acceptDeleteWithPin')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">Внимание!</div>
          <div class="tw-my-[15px]">Введите пароль администратора!</div>
          <BaseInputNew
            inputClass="tw-app-input-type-3"
            :input-name="'pincode'"
            @input="(data) => (pincode = data.value)"
          >
          </BaseInputNew>
          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('acceptDeleteWithPin')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="markAsPaid"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["vehile_modal_btn_save"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="withoutOptionsModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="320"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('withoutOptionsModal')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["reestr_fines_text_error2"] }}
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('withoutOptionsModal')"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["reestr_fines_text72"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="attachIntruderModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="320"
      @beforeClose="attachIntruderModalBeforeClose"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('attachIntruderModal')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["reestr_fines_text10"] }}
          </div>

          <div>
            <BaseSelect
              class="multiselect-type-3"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              v-model="selectsFilter.clients"
              :options="[
                { clients__id: null, clients__name: 'Не определен' },
                ...selectsData.clients,
              ]"
              label="clients__name"
              :maxHeight="200"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template
              ><template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>
          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('attachIntruderModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text48"] }}
            </button>
            <button
              @click="attachIntruder"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["reestr_fines_text73"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="markAsPaidModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="320"
      @beforeClose="attachIntruderModalBeforeClose"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('markAsPaidModal')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["reestr_fines_text51"] }}
          </div>

          <div v-html="dataLang['reestr_fines_text50']"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('markAsPaidModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text48"] }}
            </button>
            <button
              @click="markAsPaid"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["reestr_fines_text53"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="cancelFinesModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      @beforeClose="attachIntruderModalBeforeClose"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('cancelFinesModal')"
        ></button>

        <div class="">
          <div class="tw-app-modal__title">
            {{ dataLang["reestr_fines_text44"] }}
          </div>
          <div
            class="[&_ol]:tw-ml-[15px] [&_*]:tw-p-0"
            v-html="dataLang['reestr_fines_text45']"
          ></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('cancelFinesModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text48"] }}
            </button>
            <button
              @click="cancelFines"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["reestr_fines_text12"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="oneClickModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      @beforeClose="oneClickModalBeforeClose"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('oneClickModal')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            {{ dataLang["reestr_fines_text32"] }}
          </div>

          <SettingOneClickDataFines />

          <div
            class="tw-mx-[-30px] tw-bg-[#0C63AA] tw-py-[15px] tw-px-[30px] tw-text-white tw-text-[12px] tw-leading-[14px] tw-mt-[15px]"
            v-html="transformTextTranslateComputed"
          ></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('oneClickModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text48"] }}
            </button>
            <button
              @click="payOneClickSend"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["reestr_fines_text34"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="dontForgetFines"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('dontForgetFines')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["reestr_fines_text51"] }}
          </div>

          <div v-html="errorSum"></div>

          <div v-html="dataLang['reestr_toll_roads_text46']"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('dontForgetFines')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text48"] }}
            </button>
            <button
              @click="
                $modal.hide('dontForgetFines'), $modal.show('onAddBalance')
              "
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["reestr_fines_text36"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="payDoogModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('payDoogModal')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["reestr_fines_text51"] }}
          </div>

          <div v-html="dataLang['reestr_fines_text2']"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('payDoogModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text37"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="doneCancel"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('doneCancel')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["reestr_fines_text74"] }}
          </div>
          <div v-html="dataLang['reestr_fines_text75']"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('doneCancel')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text52"] }}
            </button>
            <button
              @click="$modal.hide('doneCancel')"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["reestr_fines_text53"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <gallery
      :images="gelleryList"
      :index="galleryExeples"
      @close="onCloseGallery"
    ></gallery>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import SettingOneClickDataFines from "@/components/SettingOneClickDataFines.vue";

import VueGallery from "vue-gallery";
export default {
  components: {
    VeTable,
    gallery: VueGallery,
    SettingOneClickDataFines,
  },

  data() {
    return {
      counter: 0,
      limitPaginationValue: 50,
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [
        { field: "vehicle_fines_statuses__id", value: 1, operator: "=" },
      ],

      isShowNotification: false,
      notificationData: null,
      cancelFinesData: {},
      updatedValues: {},
      computedAllPage: 1,
      currentPage: 1,
      nameValue: "",
      activePagePagination: {},
      currentId: null,
      localLoadingModal: false,
      pincode: "",
      copiedDataForFilter: [],
      topFilterParams: [],
      galleryExeples: null,
      selectsDataForModal: {
        places: [],
      },
      selectsFromModal: {
        places: [],
      },
      selectsData: {
        discount: [],
        statuses: [],
        clients: [],
      },
      errorSum: "",
      settingOneClick: {},
      transformTextTranslateComputed: "",
      selectsFilter: { discount: [], statuses: [], clients: [], type: [] },
      gelleryList: [],
      eventCustomOption: {},
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (column.field == "vehicle_fines__last_bill_date") {
            return row.settings?.vehicle_fines__last_bill_date;
          }
          if (column.field == "vehicle_fines_statuses__name") {
            return row.settings?.vehicle_fines_statuses__name;
          }
          if (column.field == "vehicle_fines__gis_discount_uptodate") {
            return row.settings?.vehicle_fines__gis_discount_uptodate;
          }
        },
      },
    };
  },
  methods: {
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
    },
    checkAcceptCheckbox(name) {
      if (this.activeSelectRowsMultiple.length) {
        switch (name) {
          case "cancelFinesModal":
            this.$modal.show("cancelFinesModal");
            break;
          case "oneClickModal":
            this.payInOneClick();
            break;
          default:
            this.$modal.show(name);
            break;
        }
      } else {
        this.$modal.show("withoutOptionsModal");
      }
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    onCloseGallery() {
      this.gelleryList = [];
      this.galleryExeples = null;
    },

    onSaveObjectFromArchive() {},
    cancelFines() {
      GeneralService.editOrCreate(`/fines/cancel`, {
        finesIds: this.activeSelectRowsMultiple,
      })
        .then((data) => {
          this.$modal.hide("doneCancel");
          this.loadData();
        })
        .catch((e) => {
          this.$modal.hide("cancelFinesModal");
          if (e.response.data.errorCode == 7) {
            this.$toast.error(this.dataLang["reestr_fines_text76"], {
              duration: 5000,
            });
          }
          if (e.response.data.errorCode == 5) {
            this.$toast.error(this.dataLang["reestr_fines_text77"], {
              duration: 5000,
            });
          }
          if (
            e.response.data.errorCode == 4 ||
            e.response.data.errorCode == 3
          ) {
            let datas = e.response.data.data;
            datas.sum = datas.pl_1;
            this.errorSum = this.computedTranslate(
              datas,
              this.dataLang["reestr_fines_text3"]
            );
            this.$modal.show("dontForgetFines");
          }
          if (e.response.data.errorCode == 6) {
            this.$toast.error(this.dataLang["reestr_fines_text78"], {
              duration: 5000,
            });
          }
        })
        .finally(() => {
          this.$modal.hide("cancelFinesModal");
          this.localLoading = false;
        });
    },
    markAsPaid() {
      this.localLoading = true;
      GeneralService.edit(
        `/fines/status/to-payed`,
        {
          ids: this.activeSelectRowsMultiple,
        },
        { params: { ...(this.pincode && { pincode: this.pincode }) } }
      )
        .then((data) => {
          this.pincode = "";
          this.$toast.success(data.data.message);
          this.$modal.hide("acceptDeleteWithPin");
          this.loadData();
        })
        .catch((e) => {
          if (e.response.status == 409) {
            this.$modal.show("acceptDeleteWithPin");
            this.messageError = e.response.data.message;
            this.$toast.error(e.response.data.message, { duration: 5000 });
          } else if (e.response.status == 400) {
            this.messageError = e.response.data.message;
            this.$toast.error(e.response.data.message, { duration: 5000 });
          }
          if (e.response.data.errorCode == 7) {
            this.$toast.error(this.dataLang["reestr_fines_text76"], {
              duration: 5000,
            });
          }
          if (e.response.data.errorCode == 5) {
            this.$toast.error(this.dataLang["reestr_fines_text77"], {
              duration: 5000,
            });
          }
          if (e.response.data.errorCode == 6) {
            this.$toast.error(this.dataLang["reestr_fines_text78"], {
              duration: 5000,
            });
          }
        })
        .finally(() => {
          this.$modal.hide("markAsPaidModal");
          this.localLoading = false;
        });
    },
    oneClickModalBeforeClose() {},

    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });

      return tranaslateLocal;
    },
    payOneClickSend() {
      GeneralService.editOrCreate(
        `/fines/pay/${this.activeSelectRowsMultiple}`,
        {
          type: "balance",
        }
      )
        .then((data) => {
          this.$toast.success(data.data.message);
          this.activeSelectRowsMultiple = [];
          this.$modal.show("payDoogModal");
          this.loadData();
        })
        .catch((e) => {
          if (e.response.data.errorCode == 7) {
            this.$toast.error(this.dataLang["reestr_fines_text76"], {
              duration: 5000,
            });
          }
          if (e.response.data.errorCode == 3) {
            this.errorSum = this.computedTranslate(
              e.response.data.data,
              this.dataLang["reestr_fines_text3"]
            );
            this.$modal.show("dontForgetFines");
          }
          if (e.response.data.errorCode == 5) {
            this.$toast.error(this.dataLang["reestr_fines_text77"], {
              duration: 5000,
            });
          }
          if (e.response.data.errorCode == 6) {
            this.$toast.error(this.dataLang["reestr_fines_text78"], {
              duration: 5000,
            });
          }
          if (e.response.data.errorCode == 1) {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          }
        })
        .finally(() => {
          this.$modal.hide("oneClickModal");
          this.settingOneClick = {};
          this.transformTextTranslateComputed = {};
        });
    },
    payInOneClick() {
      GeneralService.get(`/fines/pay/modal/${this.activeSelectRowsMultiple}`)
        .then((data) => {
          this.settingOneClick = data.data.data;
          this.$modal.show("oneClickModal");
          this.transformTextTranslateComputed = this.computedTranslate(
            this.settingOneClick.message,
            this.dataLang["reestr_fines_text1"]
          );
        })
        .catch((e) => {
          if (e.response.data.errorCode == 7) {
            this.$toast.error(this.dataLang["reestr_fines_text76"], {
              duration: 5000,
            });
          }
          if (e.response.data.errorCode == 5) {
            this.$toast.error(this.dataLang["reestr_fines_text77"], {
              duration: 5000,
            });
          }
          if (e.response.data.errorCode == 6) {
            this.$toast.error(this.dataLang["reestr_fines_text78"], {
              duration: 5000,
            });
          }
          if (e.response.data.errorCode == 1) {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          }
        });
    },

    attachIntruderModalBeforeClose() {},
    attachIntruder() {
      this.localLoading = true;
      GeneralService.edit(`/fines/attach/client`, {
        finesIds: this.activeSelectRowsMultiple,
        clientId: this.selectsFilter.clients.clients__id,
      })
        .then((data) => {
          this.$toast.success(data.data.message);
          this.loadData();
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
          if (e.response.data.errorCode == 7) {
            this.$toast.error(this.dataLang["reestr_fines_text76"], {
              duration: 5000,
            });
          }
          if (e.response.data.errorCode == 5) {
            this.$toast.error(this.dataLang["reestr_fines_text77"], {
              duration: 5000,
            });
          }
          if (e.response.data.errorCode == 6) {
            this.$toast.error(this.dataLang["reestr_fines_text78"], {
              duration: 5000,
            });
          }
          if (e.response.data?.message) {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          }
        })
        .finally(() => {
          this.selectsFilter.clients = [];
          this.localLoading = false;
          this.$modal.hide("attachIntruderModal");
        });
    },
    attachIntruderOpenModal() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show("attachIntruderModal");
      } else {
        this.$modal.show("withoutOptionsModal");
      }
    },
    resetFilter() {
      // this.$refs.mainTable.$el
      //   .querySelectorAll("input.base-input--new")
      //   .forEach((elem, index) => {
      //     elem.value = "";
      //   });
      // this.$refs.topFilter
      //   .querySelectorAll("input.base-input--new")
      //   .forEach((elem, index) => {
      //     elem.value = "";
      //   });
      this.topFilterParams = [];
      this.filter = [
        { field: "vehicle_fines_statuses__id", value: 1, operator: "=" },
      ];
      this.selectsFilter.discount = [
        {
          label: this.dataLang.reestr_fines_text777,
        },
      ];
      this.selectsFilter.type = [
        {
          label: this.dataLang.reestr_fines_text777,
        },
      ];
      this.selectsFilter.statuses = {
        label: this.dataLang["fine_status_nopayed"],
        value: 1,
      };
      this.loadData();
      this.counter++;
    },

    // On click
    // Navigate to: "Авторизация / Данные введены";
    // Animate: Smart animate;
    // Spring: { mass: 1, stiffness: 400, damping: 30 };

    deleteActionAndModal() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show("acceptDelete");
      } else {
        this.$modal.show("withoutOptionsModal");
      }
    },
    pincodeModalHandler() {},
    deleteRow(nameModal) {
      GeneralService.delete(`/objects/` + this.activeSelectRowsMultiple, {
        ...(this.pincode && { pincode: this.pincode }),
      })
        .then((data) => {
          this.loadData();
          this.$toast.success(data.data.message);
          this.$modal.hide("acceptDeleteWithPin");
          this.$modal.hide("acceptDelete");
        })
        .catch((e) => {
          if (e.response.status == 409) {
            this.$modal.show("acceptDeleteWithPin");
            this.$toast.error(e.response.data.message, { duration: 5000 });
          } else if (e.response.status == 400) {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          }
        });
    },
    loadData(page = 1) {
      this.localLoading = true;
      Promise.all([
        GeneralService.get(`/selects/field/filter_fines_table_select_discount`)
          .then((data) => {
            // this.selects.push(data.data.data.rows)

            this.selectsData.discount = this.prepareLabelsForDefaultSelects(
              data.data.data.rows,
              "allSelects",
              true
            ).filter_fines_table_select_discount;
          })
          .catch((e) => {}),
        GeneralService.get(`/fines/notification`)
          .then((data) => {
            if (!(data.data.data instanceof Array)) {
              this.isShowNotification = true;
              this.notificationData = data.data.data;
            }
          })
          .catch((e) => {}),
        GeneralService.get(
          `/clients?joins=company,statistics,verifications,comment`
        )
          .then((data) => {
            this.selectsData.clients = data.data.data.rows;
          })
          .catch((e) => {}),

        // /fines/table/main?fields=vehicle_fines_statuses__id,vehicle_fines_statuses__name&uniqueBy=vehicle_fines_statuses__id
      ]).then(() => {
        GeneralService.get(`/fines/table/main`, {
          params: {
            ...this.paginationFinesStateParams,
            ...((this.filter.length || this.topFilterParams.length) && {
              where: JSON.stringify([...this.filter, ...this.topFilterParams]),
            }),
            limit: this.limitPaginationValue,
            page: page,
          },
        })
          .then((data) => {
            this.getFinesAll(data.data.data);

            this.dataTable = data.data.data.rows;
            this.localLoading = false;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
              duration: 5000,
            });
          });
      });
    },
    topFillFilter(data) {
      // this.filter = [];
      let newValueFilter =
        data.type == "like" && data.value
          ? `;percent;${data.value};percent;`
          : data.value;
      if (!this.topFilterParams.find((x) => x.field == data.name)) {
        this.topFilterParams.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        console.log(newValueFilter);
        const index = this.topFilterParams.findIndex(
          (x) => x.field === data.name
        );

        if (index !== -1) {
          if (!newValueFilter) {
            this.topFilterParams.splice(index, 1);
          } else {
            this.topFilterParams[index].value = newValueFilter;
          }
        }

        // this.topFilterParams[
        //   this.topFilterParams.findIndex((x) => x.field == data.name)
        // ].value = newValueFilter;
      }
    },
    fillFilter(data) {
      // this.topFilterParams = [];
      let newValueFilter =
        data.type == "like" && data.value
          ? `;percent;${data.value};percent;`
          : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        const index = this.filter.findIndex((x) => x.field === data.name);

        if (index !== -1) {
          if (!newValueFilter) {
            this.filter.splice(index, 1);
          } else {
            this.filter[index].value = newValueFilter;
          }
        }
        // this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
        //   newValueFilter;
        if (data.operator && newValueFilter) {
          this.filter[
            this.filter.findIndex((x) => x.field == data.name)
          ].operator = data.operator;
        }
      }
    },
    fillGallery(datas) {
      this.localLoading = true;
      GeneralService.get(`/fines/gallery/${datas.vehicle_fines__id}`)
        .then((data) => {
          if (data.data.data.gallery.length) {
            this.gelleryList.push(...data.data.data.gallery);
            this.galleryExeples = 0;
          } else {
            this.$toast.error("Нет фотографий", { duration: 5000 });
          }
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        })
        .finally(() => {
          this.localLoading = false;
        });
    },

    openCard(datas) {
      // row.clients__blacklist_gallery.map((item) => {
      //             if (item.client_blacklist_gallery__file) {
      //               this.gelleryList.push(item.client_blacklist_gallery__file)
      //             }
      //           })

      //           this.galleryExeples = 0
      //

      let API_PATH = "";
      if (
        process.env.VUE_APP_MODE_BUILD == "serve-hmr" ||
        process.env.VUE_APP_MODE_BUILD == "testing"
      ) {
        API_PATH = "https://api.crmtest.ru";
      } else {
        API_PATH = "https://api.crmrent.com";
      }

      window
        .open(
          `${API_PATH}/fines/card/${
            datas.vehicle_fines__id
          }?employee-token=${encodeURI(
            JSON.parse(localStorage.getItem("user-token"))
          )}`,
          "_blank"
        )
        .focus();
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
    toExcel() {
      GeneralService.toSpecExcel("/fines/table/main/xlsx", {
        ...(this.pincode && { pincode: this.pincode }),
      })
        .then((data) => {
          // this.selects.push(data.data.data.rows)

          this.pincode = "";
          this.$modal.hide("acceptDeleteWithPin");
          const filename = new Date().toISOString();
          const url = window.URL.createObjectURL(data.data);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${filename}.xlsx`;
          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        .catch((e) => {
          if (e.response.status == 409) {
            this.currentMethodType = "excel";
            this.$modal.show("acceptDeleteWithPin", { type: "excel" });
            this.messageError = e.response.data.message;
          } else if (e.response.status == 400) {
            this.messageError = e.response.data.message;
            this.$modal.hide("acceptDeleteWithPin");
            this.$toast.error(e.response.data.message, { duration: 5000 });
          }
        });
    },
    ...mapActions("finesPagination", ["getFinesAll"]),
  },
  mounted() {
    this.selectsFilter.discount = {
      label: this.dataLang.reestr_fines_text777,
    };
  },
  created() {
    this.selectsFilter.statuses = {
      label: this.dataLang["fine_status_nopayed"],
      value: 1,
    };
    Promise.all([
      //   }),
    ]).then(() => {
      this.loadData();
      //   GeneralService.editOrCreate(`/integrators`, {
      //     integrators__company_id: 1,
      //     integrators__percent: 2
      //   })
      //     .then((data) => {
      //
      //     })
      //     .catch((e) => {
      //
      //       this.$toast.error('Неизвестная ошибка', {duration: 5000})
      //     })
    });
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("finesPagination", ["paginationFinesStateParams"]),
    ...mapGetters("finesPagination", ["numPages"]),
    columns() {
      return [
        {
          field: "",
          key: "a6",
          type: "checkbox",
          title: "",
          width: 5,
          align: "center",
        },
        {
          title: this.dataLang["reestr_fines_text15"],
          children: [
            {
              field: "vehicles__name",
              key: "172",
              title: this.dataLang["reestr_fines_text18"],
              align: "center",
              width: "12%",
              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>
                  </div>
                );
              },
            },
            {
              field: "vehicles__gosnumber",
              key: "163",
              title: this.dataLang["reestr_fines_text19"],
              align: "center",
              width: "7%",
              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
            },
            {
              field: "vehicle_fines__bill_id",
              key: "1533",
              title: this.dataLang["reestr_fines_text20"],
              align: "center",
              width: "10%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
            },
          ],
        },
        {
          title: this.dataLang["reestr_fines_text16"],
          children: [
            {
              field: "vehicle_fines__pay_bill_date",
              key: "134",
              title: this.dataLang["reestr_fines_text21"],
              align: "center",
              width: "6%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicle_fines__pay_bill_date
                      ? this.$time(row.vehicle_fines__pay_bill_date).format(
                          `${this.userSetting.company__tempalte_date}`
                        )
                      : ""}
                  </span>
                );
              },
            },
            {
              field: "vehicle_fines__offense_date_time",
              key: "131",
              title: this.dataLang["reestr_fines_text222"],
              align: "center",
              width: "8%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicle_fines__offense_date_time
                      ? this.$time(row.vehicle_fines__offense_date_time).format(
                          `${this.userSetting.company__tempalte_date} HH:mm`
                        )
                      : ""}
                  </span>
                );
              },
            },
            {
              field: "vehicle_fines__pay_bill_amount",
              key: "1334",
              title: this.dataLang["reestr_fines_text22"],
              align: "center",
              width: "5%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>
                  </div>
                );
              },
            },
            {
              field: "vehicle_fines__gis_discount_uptodate",
              key: "1823",
              title: this.dataLang["reestr_fines_text23"],
              align: "center",
              width: "6%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicle_fines__gis_discount_uptodate.split("-")[0] ==
                    "0000"
                      ? ""
                      : row.vehicle_fines__gis_discount_uptodate
                          .split("-")
                          .reverse()
                          .join(".")}
                  </span>
                );
              },
            },
            {
              field: "vehicle_fines__last_bill_date",
              key: "1293",
              title: this.dataLang["reestr_fines_text24"],
              align: "center",
              width: "6%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicle_fines__last_bill_date
                      ? this.$time(row.vehicle_fines__last_bill_date).format(
                          `${this.userSetting.company__tempalte_date}`
                        )
                      : ""}
                  </span>
                );
              },
            },
          ],
        },
        {
          title: this.dataLang["reestr_fines_text17"],
          children: [
            {
              field: "vehicle_fines__client_amount",
              key: "11203",
              title: this.dataLang["reestr_fines_text25"],
              align: "center",
              width: "5%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>
                  </div>
                );
              },
            },
            {
              field: "clients__name",
              key: "1223",
              title: this.dataLang["reestr_fines_text26"],
              align: "center",
              width: "10%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.clients__name ?? this.dataLang["reestr_fines_text79"]}
                  </span>
                );
              },
            },
            {
              field: "clients__id",
              key: "1253",
              title: this.dataLang["reestr_fines_text27"],
              align: "center",
              width: "4%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
            },
            {
              field: "clients__balance",
              key: "1623",
              title: this.dataLang["reestr_fines_text28"],
              align: "center",
              width: "5%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>
                  </div>
                );
              },
            },
          ],
        },
        {
          key: "7123",
          title: this.dataLang["reestr_fines_text29"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <img
                onClick={() => {
                  this.fillGallery(row);
                }}
                style={"cursor: pointer"}
                src={require(`@/assets/icons/icon-gallery.svg`)}
              />
            );
          },
        },
        {
          key: "8123",
          title: this.dataLang["reestr_fines_text30"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <img
                onClick={() => {
                  this.openCard(row);
                }}
                style={"cursor: pointer"}
                src={require(`@/assets/icons/card.svg`)}
              />
            );
          },
        },
        {
          field: "vehicle_fines_statuses__name",
          key: "9123",
          title: this.dataLang["reestr_fines_text31"],
          align: "center",
          width: 150,

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>{this.dataLang[row.vehicle_fines_statuses__name]}</span>
            );
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.indicator {
  display: flex;
  padding: 5px 0;
  border-radius: 5px;
  background-color: #23b14d;
  color: white;
  width: 80px;
  font-size: 11px;
  display: flex;
  justify-content: center;

  &--warn {
    background-color: #ff3a20;
  }
}
</style>
